import {
  StackIcon_default
} from "./chunk-3VP32CZ7.mjs";
export {
  StackIcon_default as default
};
